export const UserMenuList = [
    {
        title: 'My Info',
        page: '/profile',
        translate: 'USER_MENU.PROFILE',
    },
    {
        title: 'Logout',
        action: 'logout',
        translate: 'USER_MENU.LOGOUT',
    }
]

export const MenuList_Default = [
    {
        title: 'Dashboard',
        icon: 'fal fa-tachometer-alt-fast',
        page: '/index',
        translate: 'MENU.DASHBOARD',
    },
    {
        title: 'Device Manager',
        icon: 'fal fa-server',
        page: '/device',
        translate: 'MENU.DEVICE_MANAGER',
    },
    {
        title: 'Data Manager',
        icon: 'fal fa-database',
        page: '/data',
        translate: 'MENU.DATA_MANAGER'
    },
    { section: 'Development' },
    {
        title: 'ProDevice Manager',
        icon: 'fal fa-box-alt',
        page: '/prodevice',
        translate: 'MENU.PRODEVICE_MANAGER',
    },
    { section: 'Services' },
    // {
    //     title: 'order Manager',
    //     icon: 'fal fa-credit-card',
    //     page: '/order',
    //     translate: 'MENU.ORDER_MANAGER',
    // },
    { section: 'Others' },
    {
        title: 'Document',
        icon: 'fal fa-book',
        link: 'https://diandeng.tech/doc',
        translate: 'MENU.DOCUMENT',
    },
    {
        title: 'GitHub',
        icon: 'fab fa-github',
        link: 'https://github.com/blinker-iot',
        translate: 'GitHub',
    },
]

export const MenuList_Developer = [
    {
        title: 'Dashboard',
        icon: 'fal fa-tachometer-alt-fast',
        page: '/index',
        translate: 'MENU.DASHBOARD',
    },
    {
        title: 'Device Manager',
        icon: 'fal fa-server',
        page: '/device',
        translate: 'MENU.DEVICE_MANAGER',
    },
    {
        title: 'Data Manager',
        icon: 'fal fa-database',
        page: '/data',
        translate: 'MENU.DATA_MANAGER'
    },
    { section: 'Development' },
    {
        title: 'ProDevice Manager',
        icon: 'fal fa-box-alt',
        page: '/prodevice',
        translate: 'MENU.PRODEVICE_MANAGER',
    },
    {
        title: 'Firmware Manager',
        icon: 'fal fa-microchip',
        page: '/firmware',
        translate: 'MENU.FIRMWARE_MANAGER',
    },
    {
        title: 'Key Manager',
        icon: 'fal fa-key',
        page: '/key',
        translate: 'MENU.KEY_MANAGER',
    },
    { section: 'Services' },
    // {
    //     title: 'order Manager',
    //     icon: 'fal fa-credit-card',
    //     page: '/order',
    //     translate: 'MENU.ORDER_MANAGER',
    // },
    { section: 'Others' },
    {
        title: 'Document',
        icon: 'fal fa-book',
        link: 'https://diandeng.tech/doc',
        translate: 'MENU.DOCUMENT',
    },
    {
        title: 'GitHub',
        icon: 'fab fa-github',
        link: 'https://github.com/blinker-iot',
        translate: 'GitHub',
    },
]

export const MenuList_Admin = [
    {
        title: 'Dashboard',
        root: true,
        icon: 'far fa-tachometer-alt-slow',
        page: '/index',
        translate: 'MENU.DASHBOARD',
    },
    {
        title: 'User Manager',
        icon: 'fal fa-user-friends',
        page: '/user',
        translate: 'MENU.USER_MANAGER',
    },
    {
        title: 'Device Manager',
        icon: 'fal fa-server',
        page: '/device',
        translate: 'MENU.DEVICE_MANAGER',
    },
    {
        title: 'Data Manager',
        icon: 'fal fa-database',
        page: '/data',
        translate: 'MENU.DATA_MANAGER',
        // submenu: [
        //     {
        //         title: 'Raw Data',
        //         icon: 'fal fa-file-alt',
        //         page: '/data',
        //         translate: 'MENU.DATA_RAW',
        //     },
        //     {
        //         title: 'Visual',
        //         icon: 'fal fa-file-medical-alt',
        //         page: '/data-visual',
        //         translate: 'MENU.DATA_VISUAL',
        //     },
        //     {
        //         title: 'Data Distribution',
        //         page: '/data-distribution',
        //         icon: 'fal fa-cloud-download',
        //         translate: 'MENU.DATA_DISTRIBUTION',
        //     },
        // ]
    },
    {
        title: 'Realtime Dashboard',
        icon: 'fal fa-chart-line',
        page: '/realtime-dashboard',
        translate: 'MENU.REALTIME_DASHBOARD',
    },
    { section: 'Development' },
    // {
    //     title: 'Dev Center',
    //     icon: 'fal fa-code',
    //     translate: 'MENU.DEV_CENTER',
    //     submenu: [
    {
        title: 'ProDevice Manager',
        icon: 'fal fa-box-alt',
        page: '/prodevice',
        translate: 'MENU.PRODEVICE_MANAGER',
    },
    {
        title: 'Firmware Manager',
        icon: 'fal fa-microchip',
        page: '/firmware',
        translate: 'MENU.FIRMWARE_MANAGER',
    },
    // {
    //     title: 'Edge Computing',
    //     icon: 'fal fa-chart-network',
    //     page: '/edge',
    //     translate: 'MENU.EDGE_COMPUTING',
    // },
    // {
    //     title: 'App Version',
    //     icon: 'fal fa-mobile-android',
    //     page: '/app',
    //     translate: 'MENU.APP_VERSION',
    // },
    //     ]

    // },
    // {
    //     title: 'Settings',
    //     root: true,
    //     icon: 'fal fa-cog',
    //     page: '/settings',
    //     translate: 'MENU.SETTINGS',
    // },
    { section: 'SAAS' },
    {
        title: 'Vendor Manager',
        icon: 'fal fa-building',
        page: '/vendor',
        translate: 'MENU.VENDOR_MANAGER',
    },
    { section: 'Operating' },
    {
        title: 'Developers Review',
        icon: 'fal fa-user-shield',
        page: '/developers-review',
        translate: 'MENU.REVIEW_DEVELOPERS',
    },
    {
        title: 'Devices Review',
        icon: 'fal fa-hand-holding-box',
        page: '/devices-review',
        translate: 'MENU.REVIEW_DEVICES',
    },
    {
        title: 'User Feedback',
        root: true,
        icon: 'fal fa-comments',
        page: '/feedback',
        translate: 'MENU.FEEDBACK',
    },
    {
        title: 'Messages Manager',
        root: true,
        icon: 'fal fa-envelope',
        page: '/message',
        translate: 'MENU.MESSAGE',
    },
    {
        title: 'WX Push Manager',
        root: true,
        icon: 'fab fa-weixin',
        page: '/wx-push',
        translate: 'MENU.WX_PUSH',
    },
    // { section: 'Services' },
    // {
    //     title: 'order Manager',
    //     icon: 'fal fa-credit-card',
    //     page: '/order',
    //     translate: 'MENU.ORDER_MANAGER',
    // },
    { section: 'Settings' },
    {
        title: 'Security Manager',
        icon: 'fal fa-shield-alt',
        page: '/security',
        translate: 'MENU.SECURITY_MANAGER',
    },
    // {
    //     title: 'Settings',
    //     root: true,
    //     icon: 'fal fa-cog',
    //     page: '/settings',
    //     translate: 'MENU.SETTINGS',
    //     submenu: [
    //         // {
    //         //     title: 'Base Settings',
    //         //     icon: 'fal fa-cog',
    //         //     page: '/settings/base',
    //         //     translate: 'MENU.BASE_SETTINGS',
    //         // },
    //         // {
    //         //     title: 'Administrator',
    //         //     icon: 'fal fa-user-cog',
    //         //     page: '/settings/admin',
    //         //     translate: 'MENU.ADMIN',
    //         // },
    //         {
    //             title: 'Config Edit',
    //             icon: 'fal fa-cog',
    //             page: '/settings/config-editor',
    //             translate: 'MENU.CONFIG_EDITOR',
    //         },
    //     ]
    // },
    {
        title: 'Platform Manager',
        icon: 'fal fa-cloud',
        page: '/platform',
        translate: 'MENU.PLATFORM_MANAGER',
    },
    {
        title: 'CoAP Manager',
        icon: 'fal fa-network-wired',
        page: '/coap',
        translate: 'MENU.COAP_MANAGER',
    },
    {
        title: 'Config Edit',
        icon: 'fal fa-cog',
        page: '/settings/config-editor',
        translate: 'MENU.CONFIG_EDITOR',
    },
    {
        title: 'admin Manager',
        icon: 'fal fa-user-crown',
        page: '/admin',
        translate: 'MENU.ADMIN',
    },
    { section: 'Others' },
    {
        title: 'Document',
        icon: 'fal fa-book',
        link: 'https://diandeng.tech/doc',
        translate: 'MENU.DOCUMENT',
    },
    {
        title: 'GitHub',
        icon: 'fab fa-github',
        link: 'https://github.com/blinker-iot',
        translate: 'GitHub',
    },
]